import React from "react";
import PropTypes from "prop-types";
import SVG from "./index";

export default class Icon extends React.Component {
  constructor() {
    super();

    this.TYPE = {
      SVG: "svg",
    };
  }

  render() {
    const { className, src, type, width, height } = this.props;
    const { TYPE } = this;
    const InlineSVG = SVG[src] || ""; // Prevent error when src is missing

    return (
      <>
        {type === TYPE.SVG ? (
          InlineSVG && <InlineSVG className={`icon ${className ? `icon-${className}` : ""}`} {...this.props} />
        ) : (
          <image
            className={`icon ${className ? `icon-${className}` : ""}`}
            href={src}
            x="0"
            y="0"
            width={width}
            height={height}
          />
        )}
      </>
    );
  }
}

// ✅ Move these OUTSIDE the class
Icon.defaultProps = {
  className: "icon",
  type: "svg",
  width: 10,
  height: 10,
};

Icon.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string,
  type: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.string,
};
